import { ReactComponent as Html } from ".././assets/icons/html.svg";
import { ReactComponent as Css } from ".././assets/icons/css.svg";
import { ReactComponent as Js } from ".././assets/icons/js.svg";
import { ReactComponent as Ts } from ".././assets/icons/ts.svg";
import { ReactComponent as React } from ".././assets/icons/react.svg";
import { ReactComponent as Next } from ".././assets/icons/next.svg";
import { ReactComponent as Vue } from ".././assets/icons/vue.svg";
import { ReactComponent as Bootstrap } from ".././assets/icons/bootstrap.svg";
import { ReactComponent as Scss } from ".././assets/icons/scss.svg";
import { ReactComponent as Tailwind } from ".././assets/icons/tailwind.svg";
import { ReactComponent as Mui } from ".././assets/icons/mui.svg";
import { ReactComponent as Git } from ".././assets/icons/git.svg";
import { ReactComponent as Mongo } from ".././assets/icons/mongodb.svg";
import { ReactComponent as Express } from ".././assets/icons/express.svg";
import { ReactComponent as Node } from ".././assets/icons/node.svg";
import { ReactComponent as Redux } from ".././assets/icons/redux.svg";
import { ReactComponent as Recoil } from ".././assets/icons/recoil.svg";

export const SkillsData = [
  { svg: <Html />, name: "HTML5" },
  { svg: <Css />, name: "CSS3" },
  { svg: <Js />, name: "JavaScript" },
  { svg: <Ts />, name: "TypeScript" },
  { svg: <React />, name: "React JS" },
  { svg: <Next />, name: "Next JS" },
  { svg: <Vue />, name: "Vue JS" },
  { svg: <Tailwind />, name: "Tailwind CSS" },
  { svg: <Bootstrap />, name: "Bootstrap" },
  { svg: <Scss />, name: "SCSS" },
  { svg: <Mui />, name: "Material UI" },
  { svg: <Mongo />, name: "MongoDB" },
  { svg: <Express />, name: "Express" },
  { svg: <Node />, name: "Node.js" },
  { svg: <Git />, name: "Git" },
  { svg: <Redux />, name: "Redux" },
  { svg: <Recoil />, name: "Recoil" },
];
